import { useLayoutEffect as e } from "react";
var a = e;
export {
  a as default
};
//# sourceMappingURL=use-isomorphic-layout-effect.browser.esm.js.map
